import { useState, useEffect, useCallback } from "react";
import {  onSnapshot } from "firebase/firestore";
import { colRefs } from "../services/firestore";   
import { usePersistentState } from "../hooks/usePersistentState"; 


const EMPTY_PARTIJ = {
  snijgroep: "",
  perceel: "",
  gewicht: "",
  soort: "",
  koelcel: "",
  rij: "",
  notitie: "",
  // 🔑 nieuwe hidden ID voor deze partij-sessie
  partijCode: null,
};

export function usePartij({ currentUser, toast, enabled = true }) {
  const EMPTY_INFO = {
    snijgroep: "",
    perceel: "",
    gewicht: "",
    soort: "",
    koelcel: "",
    rij: "",
    notitie: "",
  };

  const [partijInfo, setPartijInfo] = usePersistentState(
    "kv_partijInfo",
    EMPTY_INFO
  );

  // of er al een partij liep bij de laatste keer → blijft bewaard
  const [partijGestart, setPartijGestart] = usePersistentState(
    "kv_partijGestart",
    false
  );

  // of het formulier “Partijinformatie instellen” open stond
  const [formulierVisible, setFormulierVisible] = usePersistentState(
    "kv_partijFormVisible",
    false
  );

  // validatie
  const isPartijInfoValid = useCallback(() => {
    const { snijgroep, perceel, gewicht, soort, koelcel, rij } = partijInfo;
    return snijgroep && perceel && gewicht && soort && koelcel && rij;
  }, [partijInfo]);


  // ==== start / stop partij ====
  const startNieuwePartij = () => {
  if (!currentUser) {
    toast?.error("Je moet ingelogd zijn om een partij te starten.");
    return;
  }

  //  unieke code voor deze sessie
  const nieuweCode = `p-${Date.now().toString(36)}`;

  setPartijInfo({
    ...EMPTY_PARTIJ,
    partijCode: nieuweCode,
  });

  setPartijGestart(true);
  setFormulierVisible(true);
};

  const beëindigPartij = () => {
    if (!partijGestart) return;
    
    setPartijGestart(false);
    setFormulierVisible(false);
    setPartijInfo(EMPTY_PARTIJ);
  };


  // ==== B) openOrdersMeta live ophalen ====
  const [openOrdersMeta, setOpenOrdersMeta] = useState({});

  useEffect(() => {
    if (!enabled || !currentUser) return;

    const unsub12 = onSnapshot(
      colRefs.ordersOpen("12"),
      (snap) => {
        setOpenOrdersMeta(prev => ({
          ...prev,
          "12": snap.exists() ? snap.data() : {}
        }));
      }
    );

    const unsub3 = onSnapshot(
      colRefs.ordersOpen("3"),
      (snap) => {
        setOpenOrdersMeta(prev => ({
          ...prev,
          "3": snap.exists() ? snap.data() : {}
        }));
      }
    );

    const unsub4 = onSnapshot(
      colRefs.ordersOpen("4"),
      (snap) => {
        setOpenOrdersMeta(prev => ({
          ...prev,
          "4": snap.exists() ? snap.data() : {}
        }));
      }
    );

    return () => {
      unsub12 && unsub12();
      unsub3 && unsub3();
      unsub4 && unsub4();
    };
  }, [currentUser, enabled]);


  // === Exporteren ===
  return {
    partijInfo,
    setPartijInfo,
    partijGestart,
    startNieuwePartij,
    beëindigPartij,
    isPartijInfoValid,
    formulierVisible,
    setFormulierVisible,
    openOrdersMeta
  };
}
